import React from 'react'
import styled from 'styled-components'

import Markdown from 'components/Markdown'

export default function SmallText({ content }) {
   return (
      <StyledSmallText>
         <Markdown options={{ forceBlock: true }}>{content}</Markdown>
      </StyledSmallText>
   )
}

const StyledSmallText = styled.div`
   p,
   em,
   h1,
   h2,
   h3 {
      font-size: 12px;
      line-height: 19px;
      font-weight: 300;
      letter-spacing: 0.02em;
      color: ${({ theme }) => theme.colors.disclosure};
   }

   strong {
      font-size: 12px;
      font-weight: 500;
   }
`
